export default "__VITE_ASSET__C7kfkro2__"